import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function PaymentMethodPhonePeConfigurationComponent ({handleInnerFormChange,selectRazorpay}: any) {
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
         <InputContainer
            label="Active"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event,
                'PhonePe.IsActive',
                selectRazorpay?.PhonePe
              );
            }}
            type="checkbox"
            value={selectRazorpay?.PhonePe?.IsActive}
        />
     <InputContainer
            label="Merchant Id"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'PhonePe.MerchantId',
                selectRazorpay?.PhonePe
              );
            }}
            type="text"
            value={selectRazorpay?.PhonePe?.MerchantId}
        />
     <InputContainer
            label="Salt Key"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'PhonePe.SaltKey',
                selectRazorpay?.PhonePe
              );
            }}
            type="text"
            value={selectRazorpay?.PhonePe?.SaltKey}
        />
    <InputContainer
            label="Salt Index"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'PhonePe.SaltIndex',
                selectRazorpay?.PhonePe
              );
            }}
            type="text"
            value={selectRazorpay?.PhonePe?.SaltIndex}
        />
      </div>
  }
    expandedPanel="PhonePe Configuration Info"
    headerTitle="PhonePe Configuration Info"
/>
    
        </>
  )
}